<template>
    <v-container fluid grid-list-lg class='pa-0 py-0' v-if="modules.length > 0">
      <h3 class='ml-2 mb-3'><v-icon medium class='mr-2' color='black'>fa fa-certificate</v-icon> Online Modules</h3>
      <p class='px-2'>Access online modules and earn micro credentials.</p>
        <v-layout row wrap>

            <v-flex
            class="myModuleTile"
                xs12
                sm6
                md4
                lg3
                v-for="module in modules"
                :key="module.id"
                :module="module"
            >
                <AmazeDashboardTile :group="module" class='ma-2' :link="'/module/' + module.id" :type="'Module'">
                    <template slot="card-actions">
                      <small class='latestActivity pl-2' v-if="module.completed"><v-icon small>check</v-icon>Completed</small>
                  </template>
                </AmazeDashboardTile>
            </v-flex>
            <!--<v-flex xs12 sm6 md4 lg3>-->
                <!--<AmazeDashboardIconTile class='ma-2' icon="add" text="Add a Module" link="/module/create" />-->
            <!--</v-flex>-->
        </v-layout>
    </v-container>
</template>

<style lang="scss" scoped>
  .icon-align-center {
    vertical-align: inherit;
  }
</style>

<script>
import AmazeDashboardTile from "@/components/Widgets/AmazeDashboardTile";
// import AmazeDashboardIconTile from "@/components/Widgets/AmazeDashboardIconTile";

export default {
  components: {
    AmazeDashboardTile
    //    AmazeDashboardIconTile
  },
  props: ['modules']
};
</script>
